import React from "react";
import { FiMenu } from "react-icons/fi";
import { Tooltip } from "@mui/material";

interface Props {
  toggleCollapse: () => void;
  isCollapsed: boolean;
  entityName?: React.ReactNode;
}

const Header = ({ toggleCollapse, entityName }: Props) => {
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const email = userData?.email || "";

  return (
    <div className="flex h-full min-h-[64px] w-full items-center justify-between gap-4 border-b border-white/10 bg-primary-main px-4 shadow-[0_8px_24px_rgba(36,54,66,0.18)]">
      <div className="flex h-full min-w-0 items-center">
        <Tooltip title="Alt + T">
          <button
            type="button"
            onClick={toggleCollapse}
            className="no-btn-motion block h-10 w-10 rounded-xl text-xl text-white transition-colors duration-200 hover:bg-white/10 md:hidden"
          >
            <FiMenu className="mx-auto" />
          </button>
        </Tooltip>

        <div className="truncate text-[15px] font-semibold text-white">
          {entityName}
        </div>
      </div>

      <div className="flex min-w-0 items-center justify-end gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent text-sm font-bold text-primary-main ring-2 ring-white/30">
          {userData?.name?.[0]?.toUpperCase() || email?.[0]?.toUpperCase() || ""}
        </div>
        <div className="break-all text-right text-[13px] font-medium leading-snug text-white/90">
          {email}
        </div>
      </div>
    </div>
  );
};

export default Header;
